import React from "react";
import Select from "react-select";
import useQueryParams from "../../hooks/useQueryParams";
import { useOrdersContext } from "./orders.context";

export const OrderStateFilter = () => {
  const { params, addOrUpdateParams, updateAndRemoveParams } = useQueryParams();
  const { states, myStatesOnly } = useOrdersContext();

  const onChange = ({ value }) => {
    if (value === "") updateAndRemoveParams({ page: 1 }, ["state"]);
    else addOrUpdateParams({ state: value, page: 1 });
  };
  const selectedOption = states.find((option) => option.value === (params.state || ""));

  return (
    <div className="orders-filter-state ">
      <label className="">State</label>
      <div className="orders-filter-state-select">
        <Select
          name="filter-state"
          isDisabled={myStatesOnly}
          id="filter-state"
          placeholder="Select"
          value={selectedOption}
          onChange={onChange}
          options={states}
        />
      </div>
    </div>
  );
};

export default OrderStateFilter;
